import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import BackToTop from "@/components/BackToTop";
import PassportPopup from "@/components/PassportPopup";
import { initGA4 } from "@/lib/ga4";
import Home from "@/pages/Home";
import Experiences from "@/pages/Experiences";
import GroupTravel from "@/pages/GroupTravel";
import Cruises from "@/pages/Cruises";
import Resorts from "@/pages/Resorts";
import Honeymoons from "@/pages/Honeymoons";
import Destinations from "@/pages/Destinations";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import QuotePage from "@/pages/QuotePage";
import Journal from "@/pages/Journal";
import JournalArticle from "@/pages/JournalArticle";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Thailand2027 from "@/pages/Thailand2027";
import ReadyToBook from "@/pages/ReadyToBook";
import NotFound from "@/pages/NotFound";
import Accessibility from "@/pages/Accessibility";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function AnalyticsListener() {
  useEffect(() => { initGA4(); }, []);
  return null;
}

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <AnalyticsListener />
          <SmoothScroll />
          <BackToTop />
          <PassportPopup />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/experiences" element={<Experiences />} />
            <Route path="/group-travel" element={<GroupTravel />} />
            <Route path="/cruises" element={<Cruises />} />
            <Route path="/resorts" element={<Resorts />} />
            <Route path="/honeymoons" element={<Honeymoons />} />
            <Route path="/destinations" element={<Destinations />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/start-your-journey" element={<QuotePage />} />
            <Route path="/request-a-quote" element={<Navigate to="/start-your-journey" replace />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<JournalArticle />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="/Thailand2027" element={<Thailand2027 />} />
            <Route path="/Thailand2027/" element={<Thailand2027 />} />
            <Route path="/thailand2027" element={<Thailand2027 />} />
            <Route path="/ReadyToBook" element={<ReadyToBook />} />
            <Route path="/ready-to-book" element={<ReadyToBook />} />
            <Route path="/PlanMyTrip" element={<Navigate to="/start-your-journey" replace />} />
            <Route path="/plan-my-trip" element={<Navigate to="/start-your-journey" replace />} />
            <Route path="/BookMyTrip" element={<Navigate to="/ReadyToBook" replace />} />
            <Route path="/book-my-trip" element={<Navigate to="/ReadyToBook" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" toastOptions={{ style: { background: "#0a0a0a", border: "1px solid rgba(197,160,89,0.3)", color: "#f5f5f0", borderRadius: 0 } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
